// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PairOfCards_wrapper__FmGU0","item":"PairOfCards_item__f2xtA","name":"PairOfCards_name__IJOVL","suit":"PairOfCards_suit__4v7yP","_large":"PairOfCards__large__jwpPt"};